// theme.ts
import {createTheme} from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0080A6',
      dark: '#063556',
      light: '#00B4D8',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#063556',
      light: '#395c78',
      dark: '#042a41',
      contrastText: '#ffffff',
    },
    error: {
      light: '#F16384',
      main: '#C80034',
      dark: '#B4143D',
      contrastText: '#FFFFFF',
    },
    warning: {
      light: '#FEEF66',
      main: '#FDE000',
      dark: '#CCA600',
      contrastText: '#000000',
    },
    info: {
      light: '#4BC3C8',
      main: '#038D92',
      dark: '#02656D',
      contrastText: '#FFFFFF',
    },
    success: {
      light: '#44D76A',
      main: '#00A906',
      dark: '#007A05',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F9F9F9', // gray98
      paper: '#FFFFFF', // white
    },
    text: {
      primary: '#1F1F1F', // darkerGray
      secondary: '#5F6368', // grayText
      disabled: '#B9B9B9', // gray70
    },
    grey: {
      50: '#F9F9F9', // gray98
      100: '#F2F2F2', // gray95
      200: '#E5E5E5', // gray90
      300: '#D0D0D0', // gray80
      400: '#B9B9B9', // gray70
      500: '#999999', // gray40
      600: '#707070', // gray
      700: '#444746', // darkGray
      800: '#1F1F1F', // darkerGray
    },
  },
  typography: {
    fontFamily: "'Rubik', system-ui, sans-serif",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1536,
    },
  },
});
export default theme;
